import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import MainLayout from 'layouts/MainLayout'
import Rail from 'components/Rail'
import News from 'components/News'
import Ad from 'components/Ad'
import Interest from 'components/Interest'
import SearchResult from 'components/SearchResult'
import Article from 'components/Article'
import Curriculum from 'components/Curriculum'
import Podcast from 'components/Podcast'
import Events from 'components/Events'

import stylesRC from 'components/Rail/RailCenter.module.sass'
import stylesRR from 'components/Rail/RailRight.module.sass'
import stylesRD from 'components/Rail/RailDual.module.sass'

import { getSearchTerm } from 'modules/home/HomeSelector'

const Home = () => {
  const { hash, pathname } = useLocation()
  const searchTerm = useSelector(getSearchTerm)
  const isSearching = Boolean(searchTerm?.length)
  const isArticlePage = pathname.includes('/article/')
  const isCurriculaPage = pathname.includes('/curricula')
  const isPodcastsPage = pathname.includes('/podcasts')
  const isEventsPage = pathname.includes('/live-events')
  const isNewsPage = hash === '#news'

  return (
    <MainLayout>
      {isSearching ? (
        <Rail styles={stylesRD}>
          <SearchResult />
        </Rail>
      ) : (
        <>
          <Rail styles={stylesRC}>
            {isArticlePage && <Article />}
            {isCurriculaPage && <Curriculum />}
            {isPodcastsPage && <Podcast />}
            {isEventsPage && <Events />}
            {!isArticlePage &&
              !isCurriculaPage &&
              !isPodcastsPage &&
              !isEventsPage &&
              !isNewsPage && (
                <>
                  <Ad />
                  <Interest />
                </>
              )}
          </Rail>
          <Rail styles={stylesRR}>
            <News />
          </Rail>
        </>
      )}
    </MainLayout>
  )
}

export default Home
